import { TreeItem } from '@graftcode/design-system'

import { UnifiedGraftModelTypeKey } from '@/core/const/unifiedGraftModelTypeKeys.const'
import { FIELD_BADGE_LABELS } from '@/core/hooks/useCardNavigation/utils/getFieldBadgeLabel'
import { FieldData } from '@/core/types/library.type'
import { createTreeBadgeContent } from '@/core/utils/createTreeBadgeContent'
import { getUnifiedGraftModelType } from '@/core/utils/getUnifiedGraftModelType'

const BADGE_LABEL_MAP: Record<string, string> = {
  [UnifiedGraftModelTypeKey.STATIC_FIELD]: FIELD_BADGE_LABELS.STATIC,
  [UnifiedGraftModelTypeKey.INSTANCE_FIELD]: FIELD_BADGE_LABELS.INSTANCE,
  [UnifiedGraftModelTypeKey.GLOBAL_FIELD]: FIELD_BADGE_LABELS.GLOBAL,
}

const getBadgeLabel = (type: string): string | undefined => BADGE_LABEL_MAP[type]

export const mapFieldToTreeItem = (item: FieldData, parentPath: string): TreeItem => {
  const id = `${parentPath}/${item.name}`
  const typeKey = getUnifiedGraftModelType({ unifiedGraftModelType: item.type })
  const badge = getBadgeLabel(typeKey)

  const treeItem: TreeItem = {
    id,
    label: item.name,
    url: `#${id}`,
  }

  if (badge) {
    treeItem.badge = createTreeBadgeContent(badge) as unknown as TreeItem['badge']
  }

  return treeItem
}
